<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='formData' label-position="right" :label-width="200" :rules="ruleValidate"
            @submit.native.prevent>

        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="包装批次信息" prop="packing_id">
              <div style="width: 50%;min-width: 500px;padding: 10px;border-radius: 10px;border: 1px solid #ccc">

                <Row type="flex" justify="space-around" align="middle" style="margin-bottom: 20px;">

                  <Col span="12">
                    所属基地: {{packingData.land_base_name}}
                  </Col>
                  <Col span="12">
                    所属地块: {{packingData.land_sn}}
                  </Col>

                </Row>
                <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;">

                  <Col span="12">
                    包装批次号: {{packingData.packing_sn}}
                  </Col>
                  <Col span="12">
                    包装数量(kg): {{packingData.weight}}
                  </Col>

                </Row>

                <Row type="flex" justify="space-around" align="middle" style="margin: 20px 0;">

                  <Col span="12">
                    包装材料: {{packingData.material}}
                  </Col>
                  <Col span="12">
                    包装形式: {{packingData.packing_type}}
                  </Col>

                </Row>

                <Row type="flex" justify="space-around" align="middle" >

                  <Col span="12">
                    包装日期: {{packingData.date}}
                  </Col>
                  <Col span="12">
                    备注: {{packingData.remark}}
                  </Col>

                </Row>

              </div>

            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测内容" prop="inspection_content">
              <ueditor ref="inspectionContent" :content="formData.inspection_content" :height="300"></ueditor>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="判定依据" prop="judgement_basis">
              <ueditor ref="judgementBasis" :content="formData.judgement_basis" :height="300"></ueditor>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测过程" prop="inspection_process">
              <ueditor ref="inspectionProcess" :content="formData.inspection_process" :height="300"></ueditor>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测结果" prop="inspection_result">
              <RadioGroup v-model="formData.inspection_result">
                <Radio label="合格">合格</Radio>
                <Radio label="不合格">不合格</Radio>
              </RadioGroup>
            </FormItem>
          </Col>

          <Col span="24" v-if="formData.inspection_result === '不合格'">
            <FormItem label="不合格原因" prop="failure_reason">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入不合格原因" class="perW40" v-model="formData.failure_reason"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测结果意见" prop="result_opinion">
              <Input type="textarea" :autosize="{minRows: 5,maxRows: 10}" placeholder="请输入检测结果意见" class="perW40" v-model="formData.result_opinion"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测单位" prop="inspection_enterprise">
              <Input placeholder="请输入检测单位" class="perW50" v-model="formData.inspection_enterprise"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测时间" prop="inspection_date">
              <DatePicker type="datetime" placeholder="请选择检测时间" v-model="formData.inspection_date" class="perW30"></DatePicker>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测附件" prop="attachments">
              <fileUploader ref="inspectionAttachments" :showTip="true" :maxFiles="5" :allowedFormats="['jpg', 'jpeg', 'png']"/>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="检测报告" prop="report_file">
              <fileUploader ref="inspectionReportFile" :showTip="true" :allowedFormats="['jpg', 'jpeg', 'png']"/>
            </FormItem>
          </Col>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submit">提交</Button>
        </FormItem>

      </Form>
    </card>

  </div>
</template>
<script>
import {qualityInspectionsSaveApi, qualityInspectionsInfoApi} from '@/api/processing/quality/qualityInspections'
import {plantProductionPackingInfoApi} from "@/api/processing/processing/plantProductionPacking";
import ueditor from '@/components/ueditorFrom/index'
import fileUploader from "_c/fileUploader";
import {fileFormat} from "_c/common/fileFormat";

export default {
  name: 'qualityInspectionsEdit',
  components: {ueditor, fileUploader},
  data() {
    return {
      formData: {
        inspection_id: 0,
        packing_id: 0,
        inspection_content: '',
        judgement_basis: '',
        inspection_process: '',
        inspection_result: '合格',
        failure_reason: '',
        result_opinion: '',
        inspection_enterprise: '',
        inspection_date: '',
        attachments: [],
        report_file: '',
      },
      packingData: {
        id: 0,
        land_base_name: '',
        land_sn: '',
        packing_sn: '',
        weight: '',
        material: '',
        packing_type: '',
        date: '',
        remark: '',
      },
      ruleValidate: {
        packing_id: [
          {required: true, type: 'number', min: 1, message: '请选择包装批次', trigger: 'blur'}
        ],
        inspection_content: [
          {required: true, message: '请输入检测内容', trigger: 'blur'}
        ],
        judgement_basis: [
          {required: true, message: '请输入判定依据', trigger: 'blur'}
        ],
        inspection_process: [
          {required: true, message: '请输入检测过程', trigger: 'blur'}
        ],
        inspection_result: [
          {required: true, message: '请选择判定结果', trigger: 'blur'}
        ],
        inspection_enterprise: [
          {required: true, message: '请输入检测单位', trigger: 'blur'}
        ],
        inspection_date: [
          {required: true, type: 'date', message: '请选择检测时间', trigger: 'change'}
        ],

      },
    }
  },
  mounted() {

    if (this.$route.query.packing_id !== '0' && this.$route.query.packing_id) {
      this.loadPackingData(this.$route.query.packing_id)
    }

    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }


  },
  methods: {
    //提交数据
    submit() {

      // 包装id
      this.formData.packing_id = this.packingData.id

      // 富文本获取
      this.formData.inspection_content = this.$refs.inspectionContent.contents
      this.formData.judgement_basis = this.$refs.judgementBasis.contents
      this.formData.inspection_process = this.$refs.inspectionProcess.contents

      // 附件图片获取
      // 多图
      if (this.$refs.inspectionAttachments.uploadedFiles.length > 0) {
        this.formData.attachments = this.$refs.inspectionAttachments.uploadedFiles.map(item => item.url)
      } else {
        this.formData.attachments = []
      }

      // 单图
      if (this.$refs.inspectionReportFile.uploadedFiles.length > 0) {
        this.formData.report_file = this.$refs.inspectionReportFile.uploadedFiles[0].url;
      } else {
        this.formData.report_file = ''
      }

      // 验证数据
      this.$refs.formData.validate((valid) => {
        // 打印每个值的校验结果
        if (!valid) {
          this.$Message.error('请检查输入内容!')
          return false
        } else {
          //请求接口
          qualityInspectionsSaveApi(this.formData).then(res => {
            if (res.code === 200) {
              this.$Message.success('成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })

    },

    // 编辑加载数据
    loadFormData(id) {
      qualityInspectionsInfoApi(id).then(res => {
        //数据赋值
        this.formData = res.data

        // 查询包装批次
        this.loadPackingData(this.formData.packing_id)

        // 富文本赋值
        this.$refs.inspectionContent.contents = this.formData.inspection_content
        this.$refs.judgementBasis.contents = this.formData.judgement_basis
        this.$refs.inspectionProcess.contents = this.formData.inspection_process

        // 图片赋值
        // 多图赋值
        if (this.formData.attachments) {
          this.$refs.inspectionAttachments.uploadedFiles = [];
          this.formData.attachments.forEach(item => {
            this.$refs.inspectionAttachments.uploadedFiles.push(fileFormat(item))
          })
        }
        // 单图赋值
        if (this.formData.report_file) {
          this.$refs.inspectionReportFile.uploadedFiles = [];
          this.$refs.inspectionReportFile.uploadedFiles.push(fileFormat(this.formData.report_file))
        }

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 加载包装信息
    loadPackingData(id) {
      plantProductionPackingInfoApi(id).then(res => {
        //数据赋值
        this.packingData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },


  }
}
</script>
